{
  "footer": {
    "alreadyPartner": "Already a partner?",
    "back": "Back",
    "letsgo": "Let's go",
    "login": "Login",
    "next": "Next",
    "readMore": "Find out more",
    "signUp": "Sign Up"
  },
  "formErrors": {
    "address": "This address can’t be found. Please enter an existing one",
    "businessName": "This name is not available. Please choose another",
    "email": "This email is already used",
    "verificationCode": "Invalid code"
  },
  "global": {
    "title": "Join Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Business name is too long",
      "label": "Business name",
      "required": "Required"
    },
    "businessSegment": {
      "aesthetics": "Aesthetics",
      "barber": "Barber",
      "beautician": "Beautician",
      "hair-removal": "Hair removal",
      "hairdresser": "Hairdresser",
      "massage": "Massage",
      "nails": "Nails",
      "primary": "Primary",
      "required": "Select at least one",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "I can confirm that I have a dedicated and separate room for my business",
      "home": "Home based <0>- your clients come to your home</0>",
      "mobile": "Mobile <0>- you go to your clients’ homes</0>",
      "mobileCheckbox": "I ONLY want to use Treatwell for booking software and NOT for marketplace.",
      "mobileMessage": "Unfortunately due to limitations our marketplace can only showcase a business with a fixed address.",
      "required": "Select one",
      "shop": "Shop <0>- your clients come to a shop</0>",
      "chair-rental": "Chair rental <0>- you rent a chair in a shop</0>",
      "team": "<0>You work in a team</0>",
      "alone": "<0>You work alone</0>"
    },
    "city": {
      "invalid": "City is too long",
      "label": "City",
      "required": "Required"
    },
    "country": {
      "label": "Country",
      "required": "Required"
    },
    "email": {
      "invalid": "Invalid",
      "label": "Email",
      "required": "Required"
    },
    "firstName": {
      "invalid": "Please do not use special characters",
      "label": "First name",
      "required": "Required"
    },
    "lastName": {
      "invalid": "Please do not use special characters",
      "label": "Last name",
      "required": "Required"
    },
    "marketing": {
      "label": "I would like to receive email communications to grow my business with expert advice."
    },
    "password": {
      "hint": "8 characters minimum",
      "invalid": "Password needs at least 8 characters",
      "label": "Password",
      "required": "Required"
    },
    "phoneNumber": {
      "invalid": "Invalid phone number",
      "label": "Phone number",
      "required": "Required"
    },
    "postalCode": {
      "invalid": "Postal code is too long",
      "label": "Post code",
      "required": "Required"
    },
    "privacy": {
      "label": "By signing up for the Freemium Account you agree to our <0>privacy policy</0> and <1>terms and conditions</1>"
    },
    "searchBusiness": {
      "label": "Search business"
    },
    "street": {
      "invalid": "Address is too long",
      "label": "Address",
      "required": "Required"
    }
  },
  "salesMode": {
    "enterPassword": "Enter password for sales mode",
    "invalidPassword": "Invalid password"
  },
  "stepContext": {
    "attractNewClients": "Attract new clients",
    "buildRelationships": "Build even better relationships with your clients",
    "growBusiness": "Grow your business beautifully",
    "manageAppointments": "Manage all your appointments on the go",
    "prompt": "You’re just a few easy steps (and about 3 minutes) away from joining over 75,000 salons managing their businesses, growing their client bases and their revenue.<br /><br />With Treatwell you will be able to:",
    "prompt2": "...and much more.",
    "title": "<0>Joining Treatwell</0> - Europe’s largest hair and beauty salon platform - has never been so simple."
  },
  "stepCounter": {
    "step0": "Step 1",
    "step1": "Step 1",
    "step2": "Step 2",
    "step3": "Step 3",
    "step4": "Step 4",
    "step5": "Congratulations"
  },
  "stepEmailVerification": {
    "resend": "Resend",
    "subTitle1": "Simply enter the code to complete your sign-up.",
    "subTitle2": "Didn’t receive it?",
    "title": "<0>Almost there,</0> we have sent you an email with a 6 digit code!"
  },
  "stepError": {
    "accountCreation": "creating your account",
    "body": "We are facing problems.\nPlease wait a minute and give it another try.",
    "bodyWithError": "We are facing problems with {{reason}}.\nPlease wait a minute and give it another try.",
    "button": "Retry",
    "title": "Oops, Something went wrong!"
  },
  "stepFinal": {
    "joke1Punchline": "A shampoodle!",
    "joke1Setup": "What dog does a hairdresser own?",
    "joke2Punchline": "By taking a short cut!",
    "joke2Setup": "How did the hairdresser win the race?",
    "joke3Punchline": "A Barbecue!",
    "joke3Setup": "What do you call a line of men waiting for a haircut?",
    "joke4Punchline": "Eclipse it!",
    "joke4Setup": "How does the man in the moon cut his hair?",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "While you wait, these are hair-larious",
    "title": "Thanks, lets set up your business!<br />Give us <0>two minutes...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Sign Up",
    "alternativeMessage": "Are you using the same location to sign up a new business?",
    "button": "Treatwell Login",
    "message": "<0>Good news!</0> Your business is already setup with Treatwell."
  },
  "stepFourForm": {
    "prompt1": "We will use this information to create your account and reach out if we need to",
    "title": "Tell us about you"
  },
  "stepOneForm": {
    "prompt1": "Search or enter your business name",
    "title": "Tell us about your business"
  },
  "stepOneSearch": {
    "addManually": "Can't find your business? <0>Add it manually</0>",
    "prompt1": "Type your business name",
    "title": "Tell us about your business"
  },
  "stepThreeForm": {
    "title": "What type of business do you have?"
  },
  "stepTwoForm": {
    "prompt1": "Select all that apply, your primary service first",
    "title": "What services do you offer?"
  }
}
